module.exports = __webpack_public_path__ + "img/fd815a27a857a19c7da41245fe3d5382.a09a4e8c.png";